module.exports = __webpack_public_path__ + "assets/img/kakao_icon.63b226dd.png";